import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { DownloadTokenResultDto, GetByIdsInputDto } from '../dtos/shared/models';
import type { GetStandSoilsInputDto, StandSoilCreateDto, StandSoilDto, StandSoilExcelDownloadDto, StandSoilUpdateDto } from '../dtos/stand-soil/models';

@Injectable({
  providedIn: 'root',
})
export class StandSoilService {
  private restService = inject(RestService);
  apiName = 'Geographic';
  

  create = (input: StandSoilCreateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, StandSoilDto>({
      method: 'POST',
      url: '/api/geographic/standSoils',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  createMany = (input: StandSoilCreateDto[], config?: Partial<Rest.Config>) =>
    this.restService.request<any, number>({
      method: 'POST',
      url: '/api/geographic/standSoils/many',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  delete = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/geographic/standSoils/${id}`,
    },
    { apiName: this.apiName,...config });
  

  deleteAll = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, number>({
      method: 'DELETE',
      url: '/api/geographic/standSoils/all',
    },
    { apiName: this.apiName,...config });
  

  deleteByIds = (ids: number[], config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: '/api/geographic/standSoils',
      params: { ids },
    },
    { apiName: this.apiName,...config });
  

  get = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, StandSoilDto>({
      method: 'GET',
      url: `/api/geographic/standSoils/${id}`,
    },
    { apiName: this.apiName,...config });
  

  getDownloadToken = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, DownloadTokenResultDto>({
      method: 'GET',
      url: '/api/geographic/standSoils/download-token',
    },
    { apiName: this.apiName,...config });
  

  getList = (input: GetStandSoilsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<StandSoilDto>>({
      method: 'GET',
      url: '/api/geographic/standSoils',
      params: { standLocationId: input.standLocationId, soilUnitId: input.soilUnitId, standSoilArea: input.standSoilArea, standSoilAreaFrom: input.standSoilAreaFrom, standSoilAreaTo: input.standSoilAreaTo, standSoilPercentage: input.standSoilPercentage, standSoilPercentageFrom: input.standSoilPercentageFrom, standSoilPercentageTo: input.standSoilPercentageTo, isMainSoil: input.isMainSoil, strategicCommercialZoneId: input.strategicCommercialZoneId, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListAsExcelFile = (input: StandSoilExcelDownloadDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, Blob>({
      method: 'GET',
      responseType: 'blob',
      url: '/api/geographic/standSoils/as-excel-file',
      params: { downloadToken: input.downloadToken, fields: input.fields, standLocationId: input.standLocationId, soilUnitId: input.soilUnitId, standSoilArea: input.standSoilArea, standSoilAreaFrom: input.standSoilAreaFrom, standSoilAreaTo: input.standSoilAreaTo, standSoilPercentage: input.standSoilPercentage, standSoilPercentageFrom: input.standSoilPercentageFrom, standSoilPercentageTo: input.standSoilPercentageTo, isMainSoil: input.isMainSoil, strategicCommercialZoneId: input.strategicCommercialZoneId, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListByIds = (input: GetByIdsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, StandSoilDto[]>({
      method: 'GET',
      url: '/api/geographic/standSoils/by-ids',
      params: { ids: input.ids },
    },
    { apiName: this.apiName,...config });
  

  update = (id: number, input: StandSoilUpdateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, StandSoilDto>({
      method: 'PUT',
      url: `/api/geographic/standSoils/${id}`,
      body: input,
    },
    { apiName: this.apiName,...config });
}